import { render, staticRenderFns } from "./StudentPromotion.vue?vue&type=template&id=0efd6916&scoped=true"
import script from "./StudentPromotion.vue?vue&type=script&lang=js"
export * from "./StudentPromotion.vue?vue&type=script&lang=js"
import style0 from "./StudentPromotion.vue?vue&type=style&index=0&id=0efd6916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd6916",
  null
  
)

export default component.exports